import { utils } from "@alife/cone-arms-core";
import { supportedEntryType, getContainerComponentName, mergeAndSliceEventList } from "./utils";
var checkWin = utils.checkWin, getXPath = utils.getXPath, bindEvent = utils.bindEvent, watchPageVisibilityChange = utils.watchPageVisibilityChange;
var entryType = "longtask";
export var initLongTaskObserver = function() {
    var longTaskList = [];
    if (!(checkWin() && supportedEntryType(entryType))) {
        return;
    }
    var lastEventTarget = null;
    var lastEventType = "";
    var unbindHandleList = [];
    [
        "mousedown",
        "keydown",
        "mouseover"
    ].forEach(function(event) {
        unbindHandleList.push(bindEvent(document, event, function(e) {
            // 获取最后的触发事件节点
            lastEventTarget = e.target;
            lastEventType = event;
        }, true));
    });
    var observerLongTask = new PerformanceObserver(function(list) {
        // eslint-disable-next-line array-callback-return
        list.getEntries().forEach(function(entry) {
            // 过滤掉持续时间小于50ms的任务, 并且最多只记录100条数据,防止因为计算量过大导致页面卡顿，造成更多的长任务，导致性能问题
            if (entry.duration > 50 && longTaskList.length < 100) {
                longTaskList.push({
                    // 持续时间
                    duration: entry.duration,
                    // 事件类型，关联事件的类型
                    eventType: lastEventType,
                    target: lastEventTarget ? getXPath(lastEventTarget, 5) : "",
                    componentName: getContainerComponentName(lastEventTarget)
                });
            }
        });
    });
    try {
        observerLongTask.observe({
            type: entryType,
            buffered: true
        });
    } catch (e) {
    // do nothing
    }
    var pageVisibilityChangeHandle = function(isVisible) {
        if (!isVisible) {
            observerLongTask && observerLongTask.disconnect();
        } else {
            setTimeout(function() {
                try {
                    observerLongTask.observe({
                        type: entryType,
                        buffered: true
                    });
                } catch (ex) {
                // do nothing
                }
            }, 100);
        }
    };
    watchPageVisibilityChange(function(isVisible) {
        pageVisibilityChangeHandle(isVisible);
    });
    return {
        reset: function() {
            longTaskList = [];
        },
        unbind: function() {
            observerLongTask && observerLongTask.disconnect();
            unbindHandleList.forEach(function(unbindHandle) {
                unbindHandle && unbindHandle();
            });
            pageVisibilityChangeHandle = function() {};
        },
        getData: function() {
            return mergeAndSliceEventList(longTaskList, 10);
        },
        getLongTaskCount: function() {
            return longTaskList.length;
        }
    };
};

 //# sourceMappingURL=observe-long-task.js.map